module.exports = "https://cdn.dove.it/_next/static/public/assets/features/buy-from-private.c3b7ad4a6530d80a112e573b5b57194f.jpg";